import { render, staticRenderFns } from "./ModelView.vue?vue&type=template&id=062407b7&scoped=true&"
import script from "./ModelView.vue?vue&type=script&lang=ts&"
export * from "./ModelView.vue?vue&type=script&lang=ts&"
import style0 from "./ModelView.vue?vue&type=style&index=0&id=062407b7&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062407b7",
  null
  
)

export default component.exports